import { useMemo, useState, useCallback } from "react";
import { DashboardResponse } from "../../types/dashboard";
import { api } from "../../utils/api";
import { transformWeeklyData } from "../../utils/dashboardUtils";

export const useDashboard = () => {
  const [dashboardData, setDashboardData] = useState<DashboardResponse | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleError = (error: any) => {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "알 수 없는 오류가 발생했습니다.";
    setError(errorMessage);
  };

  const getDashboardData = useCallback(async () => {
    setIsLoading(true);
    try {
        const response = await api.get<DashboardResponse>("/admin/v1/dashboard");
        if (response.data.status) {
            setDashboardData(response.data);
        } else {
            throw new Error("API 응답 상태가 실패입니다.");
        }
    } catch (error) {
        handleError(error);
    } finally {
        setIsLoading(false);
    }
  }, []);
  
  const transformedData = useMemo(() => {
    if (!dashboardData?.data) return null;
    
    return {
      weeklyRegistUser: transformWeeklyData(dashboardData.data.weekly_regist_user),
      weeklyCompleteSurvey: transformWeeklyData(dashboardData.data.weekly_complete_survey),
    };
  }, [dashboardData]);

  return { dashboardData, isLoading, error, getDashboardData, transformedData };
};